import React, { Component } from 'react';

class Header extends Component {
  render() {
    return(
      <header className="calculator-header">
        <h1>Credit calculator</h1>
      </header>
    );
  }
}

export default Header;